import * as React from 'react';

import Checkbox from 'src/components/common/Checkbox';
import RadioButton from 'src/components/common/RadioButton';

import LocationModel from 'src/model/location.model';
import ItemModel from 'src/model/cartItem.model';
import CreditCardModel from 'src/model/creditCard.model';
import checkoutServiceInstance, {
  IShippingMethod
} from 'src/services/checkout/CheckoutService';

import { ifLoggedIn, goToCart, cartUrl } from 'src/utils/navigation';
import './CheckoutCard.scss';
import env from '../../../../shared/env';
import UserModel from 'src/model/user.model';
import Loader from 'src/components/common/Loader';

interface ICheckoutCardProps {
  orderConfirmed: boolean;
  accountId: string;
  name: string;
  email: string;
  phone: string;
  itemsQty: number;
  deliverMethod: string;
  deliveryLocation: LocationModel;
  items: { [key: number]: ItemModel };
  deliverAllAtOnce: boolean;
  paymentMethod: string;
  allowChangePaymentMethod: boolean;
  defaultShippingMethod: string;
  shippingMethod: IShippingMethod;
  shippingMethodGlobal: IShippingMethod;
  termsOfDelivery: string;
  PONumber: string;
  stateUnitNumber: string;
  stateServiceNumber: string;
  stateTechId: string;
  ponumberRequired: boolean;
  savedCreditCards: CreditCardModel[];
  selectedCreditCard: CreditCardModel;
  handleDeliverAllAtOnceChange: () => void;
  handleShowChangePaymentMethod: () => void;
  handleSelectShippingMethodChange: (shippingMethod: IShippingMethod) => void;
  handlePONumberChange: (PONumber: string) => void;
  handlePaymentMethodSave: (e: any) => void;
  handleAllUnitNumberChange: (stateUnitNumber: string) => void;
  handleAllServiceNumberChange: (stateTechId: string) => void;
  handleAllTechIdNumberChange: (techID: any) => void;
  handleSelectCreditCard(creditCard: CreditCardModel): void;
  t?: any;
  emailUpdated: any;
}

interface ICheckoutState {
  showShippingMethodDropDown: boolean;
  shippingMethods: IShippingMethod[];
  unit: string;
  serviceOrder: string;
  techID: string;
  isEditing: boolean;
  isEmailEditing: boolean;
  phoneValue: string;
  emailValue: string;
  isValid: boolean;
  phoneFormate: string;
  successAlert: boolean;
  pending:boolean;
  successMsg:boolean;
  successEmailMsg:boolean;
  successEmailPhoneMsg:boolean;
}

class CheckoutCard extends React.Component<ICheckoutCardProps, ICheckoutState> {
  public shippingDropdown: any;

  constructor(props: any) {
    super(props);
    this.shippingDropdown = React.createRef();
    this.state = {
      showShippingMethodDropDown: false,
      shippingMethods: [],
      unit: '',
      serviceOrder: '',
      techID: '',
      isEditing: false,
      isEmailEditing: false,
      phoneValue:this.props.phone,
      emailValue:this.props.email,
      isValid:false,
      phoneFormate:this.formatPhoneNumber(this.props.phone?.replace("+1", '')),
      successAlert: false,
      pending: false,
      successMsg:false,
      successEmailMsg:false,
      successEmailPhoneMsg:false
    };
  }

  private goToCart = () => ifLoggedIn(() => goToCart());

  private handleShowShippingMethodDropDown = () => {
    this.setState(prevState => ({
      showShippingMethodDropDown: !prevState.showShippingMethodDropDown
    }));
  };

  // email editing
   private handleEmailEditClick = () => {
     this.setState({ isEmailEditing: true });
     this.setState({ isEditing: false });
     this.setState({successMsg:false});
     this.setState({successEmailMsg:false});
     this.setState({successEmailPhoneMsg:false});
     

     if(localStorage.getItem("orderEmail") !== null) {   
        this.setState({ emailValue:localStorage.getItem("orderEmail") });
      } else {
        this.setState({ emailValue:this.props.email });
      }
   };
 
   private handleCancelEmailEdit = () => {
     this.setState({ isEmailEditing: false });
   };
 
   private handleEmailInputChange = (e:any) => {
     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
 
     this.setState({ emailValue: e.target.value, isValid: emailRegex.test(e.target.value) });
   }
 
   // phone editing
   private handlePhoneEditClick = () => {
     this.setState({ isEditing: true });
     this.setState({ isEmailEditing: false });
     this.setState({successMsg:false});
     this.setState({successEmailMsg:false});
     this.setState({successEmailPhoneMsg:false});
     

     if(localStorage.getItem("orderPhone") !== null) {   
        this.setState({ phoneFormate:this.formatPhoneNumber(localStorage.getItem("orderPhone")?.replace("+1", '')) });
      } else {
        this.setState({ phoneFormate:this.formatPhoneNumber(this.props.phone?.replace("+1", '')) });
      }
   };
   
 
   private handleCancelPhoneEdit = () => {
     this.setState({ isEditing: false });
   };
 
   private handlePhoneInputChange = (e:any) => {
 
     const formattedInput = this.formatPhoneNumber(e.target.value);
 
     if (formattedInput.length <= 14) {
       const phoneVal = formattedInput.replace(/[()\s-]/g, '');
       this.setState({ phoneValue: phoneVal, isValid: formattedInput.length === 14,phoneFormate:formattedInput });
     }
   }
 
   private formatPhoneNumber = (value:any) => {
     const phoneNumber = value ? value.replace(/[^\d]/g, '') : '';
     const phoneNumberLength = phoneNumber.length;
 
     if (phoneNumberLength < 4) { 
       return phoneNumber; 
     }
     if (phoneNumberLength < 7) {
       return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
     }
     return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
   };
 
   private handleEmailSaveClick = (updateField:any) => {
 
     if(this.props.email !== this.state.emailValue ) {
 
       this.setState({ isEmailEditing: false,pending:true });
       // Add logic to save the updated phone number
       localStorage.setItem("orderEmail",this.state.emailValue);
       localStorage.setItem("isOrderEmailPhoneUpdated",'true');
       /*
       this.props.updateUserInfo(
         this.state.emailValue.toLowerCase(),
         this.props.phone,
         ''
       ); */
       localStorage.setItem("emailupdateCheckout","yes");
       this.setState({successEmailMsg:true});
       this.setState({successEmailPhoneMsg:true});
       
       setTimeout(() => {
         this.setState({ successEmailMsg: false });
       }, 5000);

       setTimeout(() => {
         this.setState({ successEmailPhoneMsg: false });
       }, 15000);
 
     }
     
     
   };
 
 
   private handlePhoneSaveClick = (updateField:any) => {
     if(this.props.phone !== this.state.phoneValue ) {
       this.setState({ isEditing: false,pending:true ,successMsg:true,successEmailPhoneMsg:true});
       localStorage.setItem("orderPhone",this.state.phoneValue);
       localStorage.setItem("isOrderEmailPhoneUpdated",'true');
       this.setState({successMsg:true});
       setTimeout(() => {
         this.setState({ successMsg: false });
       }, 5000);  

       setTimeout(() => {
         this.setState({ successEmailPhoneMsg: false });
       }, 15000); 
     } 
     
   };

  private getShipFrom = () => {
    let currentState: string = '';
    let times: number = 0;
    const { t } = this.props;
    for (const key in this.props.items) {
      if (this.props.items.hasOwnProperty(key)) {
        const state = `${
          this.props.items[key].shipsfrom.addressLine4
            ? `${this.props.items[
                key
              ].shipsfrom.addressLine4.toLocaleLowerCase()}, `
            : ''
        }${
          this.props.items[key].shipsfrom.stateCode
            ? `${this.props.items[key].shipsfrom.stateCode.toUpperCase()}`
            : ''
        }`;
        if (times === 0) {
          currentState = state;
        }
        if (state && state !== currentState) {
          return (
            <div className="shipping-from">
              <p>{t('cartPage.differentLocations')} </p>
              <p>{t('cartPage.viewItemsBelow')}</p>
            </div>
          );
        }
        times++;
      }
    }
    return currentState ? (
      <div className="shipping-from">{currentState}</div>
    ) : (
      <div className="shipping-from">{t('checkoutPage.noInfoAvailable')}.</div>
    );
  };

  private handleChangePaymentMethod = (e: any) => {
    this.props.handlePaymentMethodSave(e.target.value);
  };

  private handleSelectCard = (creditCard: CreditCardModel) => {
    this.props.handleSelectCreditCard(creditCard);
  };

  private handleClickOutside = (e: any) => {
    if (
      this.shippingDropdown == null ||
      this.shippingDropdown.contains == null
    ) {
      return;
    }
    if (this.shippingDropdown.contains(e.target)) {
      // The click is inside, continue whit what we are doing
      return;
    }
    // The click is outside, hide dropdown
    this.setState({
      showShippingMethodDropDown: false
    });
  };

  public componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside, false);
    checkoutServiceInstance
      .getShippingMethods(this.props.deliverMethod === 'Delivery')
      .then(res => {
        res.forEach(method => {
          if (method.motcode === this.props.defaultShippingMethod) {
            this.props.handleSelectShippingMethodChange({
              motcode: this.props.defaultShippingMethod,
              motdescription: method.motdescription
            });
          }
        });
        this.setState({ shippingMethods: res });
        if (
          this.props.shippingMethod &&
          !!!this.props.shippingMethod.motcode &&
          res.length > 0
        ) {
          if (env.REACT_APP_BASE_ENVIRONMENT === 'CA') {
            this.props.handleSelectShippingMethodChange(res[0]);
          } else {
            const targetresult = res.find(result => result.motcode === 'C1');
            if (targetresult) {
              this.props.handleSelectShippingMethodChange(targetresult);
            } else {
              this.props.handleSelectShippingMethodChange(res[1]);
            }
          }
        } else {
          this.props.handleSelectShippingMethodChange(res[0]);
        }
      });
  }

  public componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside, false);
  }

  private renderCreditCardOptions = () => {
    const { t } = this.props;
    return this.props.orderConfirmed ? (
      this.props.paymentMethod === '004' ? (
        <div className="rp-checkout--selected-credit-card">
          <div>{this.props.selectedCreditCard.type}</div>
          <div>{`**** **** **** ${this.props.selectedCreditCard.number}`}</div>
        </div>
      ) : (
        <React.Fragment>
          <p>{t('checkoutPage.payByCreditCard')}</p>
        </React.Fragment>
      )
    ) : (
      <div>
        {this.props.savedCreditCards.length > 0 && (
          <React.Fragment>
            <RadioButton
              name={t('checkoutPage.useOnofSavedCards')}
              value={'004'}
              checked={this.props.paymentMethod === '004' ? true : false}
              className="rp-radio-button--saved-cards"
              onChange={this.handleChangePaymentMethod}
            />
            {this.props.paymentMethod === '004' && (
              <div>
                {this.props.savedCreditCards.map(card => (
                  <RadioButton
                    key={card.id}
                    name={`**** **** **** ${card.number}`}
                    extraText={card.type}
                    value={card.id}
                    checked={
                      card.id === this.props.selectedCreditCard.id
                        ? true
                        : false
                    }
                    className="rp-radio-button--saved-card"
                    onChange={e => this.handleSelectCard(card)}
                  />
                ))}
              </div>
            )}
          </React.Fragment>
        )}
        <RadioButton
          name={t('checkoutPage.useAnotherCard')}
          value={'002'}
          checked={this.props.paymentMethod === '002' ? true : false}
          className="rp-radio-button--another-card"
          onChange={this.handleChangePaymentMethod}
        />
      </div>
    );
  };

  private renderPONumber() {
    const { t } = this.props;
    return (
      <div className="col-md-3 rp-checkout-card--shipping-info--field">
        <label>
          {t('myReturns.pONumber')}{' '}
          {this.props.ponumberRequired && (
            <span className="ponumberRequired">*</span>
          )}
          :
        </label>
        {this.props.orderConfirmed ? (
          this.props.PONumber
        ) : (
          <input
            className="po-number"
            name="po-number"
            type="text"
            value={this.props.PONumber}
            onChange={e => this.props.handlePONumberChange(e.target.value)}
          />
        )}
      </div>
    );
  }

  public render() {
    const { t } = this.props;
    const activeAccount = localStorage.getItem('activeAccount');
    return (
      <div className="rp-checkout-card">
        <div className="rp-checkout-card--title">
          {t('common.checkout')}{' '}
          <span>
            {this.props.itemsQty} {t('common.items_plural')}
          </span>
        </div>
        <div className="rp-checkout-card--account">
          {t('accountMonthlyStatements.account')}: #{this.props.accountId}
        </div>
        <div className="rp-checkout-card--account-info">
          <div className="rp-checkout-card--account-info--title">
            {t('checkoutPage.accountInfo')}
          </div>
          <div className="rp-checkout-card--account-info--field">
            <label>{t('common.name')}:</label>
            {this.props.name}
          </div>
          <div className="rp-checkout-card--account-info--field">
            <label>{t('common.email')}:</label>
            {this.state.isEmailEditing ? (
               <input className="email_edit"
                 type="text"
                 value={this.state.emailValue}
                 onChange={this.handleEmailInputChange}
               />
             ) : (
               <>
               {localStorage.getItem("orderEmail")?localStorage.getItem("orderEmail"):this.props.email}
               {!this.props.orderConfirmed && (<a className="rp-checkout-card--link" href="javascript:void(0)" onClick={this.handleEmailEditClick}>{t('checkoutPage.emailPhoneEditButton')}</a> )}         
               </>
             )}
             {this.state.isEmailEditing && (<><button className="primary-button phoneUpdate" onClick={this.handleEmailSaveClick} disabled={!this.state.isValid}>{t('checkoutPage.emailPhoneSaveButton')}</button> <span className="primary-button phoneUpdate" onClick={this.handleCancelEmailEdit} >{t('checkoutPage.emailPhoneCancelButton')}</span></>)
            }
            {this.state.successEmailMsg && (!this.state.isEmailEditing) && (<div className="sucessUpdatePhone">{t('checkoutPage.emailSaved')}</div>)}
          </div>
          <div className="rp-checkout-card--account-info--field">
            <label>{t('common.phone')}:</label>
            {this.state.isEditing ? (
         <input className="phone_edit"
           type="text"
           value={this.state.phoneFormate}
           onChange={this.handlePhoneInputChange}
         />
       ) : (
         <>
          {localStorage.getItem("orderPhone")?
         '+1' + this.formatPhoneNumber(localStorage.getItem("orderPhone")?.replace("+1", '')):
         '+1' + this.formatPhoneNumber(this.props.phone?.replace("+1", ''))}
         {!this.props.orderConfirmed && (
         <a className="rp-checkout-card--link" href="javascript:void(0)" onClick={this.handlePhoneEditClick}>{t('checkoutPage.emailPhoneEditButton')}</a>          
         )}</>
       )}
       {this.state.isEditing && (<><div><button className="primary-button phoneUpdate" onClick={this.handlePhoneSaveClick} disabled={!this.state.isValid}>{t('checkoutPage.emailPhoneSaveButton')}</button> <span className="primary-button phoneUpdate" onClick={this.handleCancelPhoneEdit} >{t('checkoutPage.emailPhoneCancelButton')}</span></div></>)
       }
 
       {this.state.successMsg && (!this.state.isEditing) && (<div className="sucessUpdatePhone">{t('checkoutPage.phoneSaved')}</div>)}
          </div>
        </div>

        {this.state.successEmailPhoneMsg && (!this.state.isEmailEditing || !this.state.isEditing) && (<div className="onemailphoneEdit">{t('checkoutPage.orderNotify')}</div>)}
        
          
        <div className="rp-checkout-card--shipping-info">
          <div className="rp-checkout-card--shipping-info--title">
            {this.props.deliverMethod === 'Shipping'
              ? `${t('checkoutPage.shippingInfo')}`
              : this.props.deliverMethod === 'Delivery'
              ? `${t('delivery.yourDeliveryLocation')}`
              : `${t('cartPage.yourPickStore')}`}
            {!this.props.orderConfirmed && (
              <a
                href={cartUrl()}
                className="rp-checkout-card--link"
                onClick={this.goToCart}
              >
                {t('common.editActionTxt')}
              </a>
            )}
          </div>
          <div className="row">
            <div className="col-md-3 rp-checkout-card--shipping-info--field">
              {this.props.deliverMethod === 'Shipping' && 'Shipping to:' ? (
                <label>
                  {this.props.deliverMethod === 'Shipping' &&
                    `${t('checkoutPage.shippingTo')}:`}
                </label>
              ) : (
                ''
              )}
              <div className="rp-checkout-card--shipping-info--shipping-to">
                <p className="rp-checkout-card--shipping-info--shipping-to--name">
                  {this.props.deliveryLocation &&
                  this.props.deliveryLocation.name !== ''
                    ? this.props.deliveryLocation.name
                    : 'N/A'}
                </p>
                <p className="rp-checkout-card--shipping-info--shipping-to--address">
                  {this.props.deliveryLocation
                    ? `${
                        this.props.deliveryLocation.addressLine1
                          ? `${this.props.deliveryLocation.addressLine1.toLocaleLowerCase()}, `
                          : ''
                      }${
                        this.props.deliveryLocation.addressLine2
                          ? `${this.props.deliveryLocation.addressLine2.toLocaleLowerCase()}, `
                          : ''
                      }${
                        this.props.deliveryLocation.addressLine4
                          ? `${this.props.deliveryLocation.addressLine4.toLocaleLowerCase()}, `
                          : ''
                      }${
                        this.props.deliveryLocation.stateCode
                          ? `${this.props.deliveryLocation.stateCode} `
                          : ''
                      }${
                        this.props.deliveryLocation.postalCode
                          ? `${this.props.deliveryLocation.postalCode}`
                          : ''
                      }`
                    : 'N/A'}
                </p>
              </div>
            </div>
            {this.props.deliverMethod === 'Shipping' && (
              <div className="col-md-2 rp-checkout-card--shipping-info--field">
                <label>{t('checkoutPage.shippingFrom')}:</label>
                {this.getShipFrom()}
              </div>
            )}
            {(this.props.deliverMethod === 'Shipping' ||
              this.props.deliverMethod === 'Delivery') && (
              <div className="col-md-3 rp-checkout-card--shipping-info--field">
                <label>{t('checkoutPage.shippingMethod')}:</label>
                {this.props.orderConfirmed ? (
                  this.props.shippingMethodGlobal.motdescription
                ) : this.props.deliverMethod === 'Delivery' ? (
                  this.props.shippingMethod &&
                  this.props.shippingMethod.motdescription
                ) : (
                  <div
                    onClick={this.handleShowShippingMethodDropDown}
                    className="combobox dropdown"
                  >
                    <div tabIndex={0} className="dropdown-box">
                      {this.props.shippingMethod &&
                        this.props.shippingMethod.motdescription}
                    </div>
                    <div tabIndex={-1} className="downarrow">
                      <span
                        className={
                          this.state.showShippingMethodDropDown
                            ? 'rpds-arrow-drop-up'
                            : 'rpds-arrow-drop-down'
                        }
                      />
                    </div>
                    {this.state.showShippingMethodDropDown && (
                      <div
                        className="dropdown-list"
                        ref={shippingDropdown =>
                          (this.shippingDropdown = shippingDropdown)
                        }
                      >
                        {this.state.shippingMethods.map(method => (
                          <div
                            className="dropdown-list-option"
                            key={method.motcode}
                            onClick={e =>
                              this.props.handleSelectShippingMethodChange(
                                method
                              )
                            }
                          >
                            {method.motdescription}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
            {this.props.deliverMethod === 'Shipping' ||
            this.props.deliverMethod === 'Delivery' ? (
              this.renderPONumber()
            ) : (
              <React.Fragment>
                {this.renderPONumber()}
              </React.Fragment>
            )}
            {!this.props.orderConfirmed && (
                <div className="col-md-3 rp-checkout-card--shipping-info--field checkbox">
                  <Checkbox
                    name={t('checkoutPage.deliverAllGoods')}
                    value={'deliverAll'}
                    checked={this.props.deliverAllAtOnce}
                    onChange={e => this.props.handleDeliverAllAtOnceChange()}
                  />
                </div>
            )}
          </div>
          
        </div>
        {localStorage.getItem('allowedUserForExtraField') === 'true' ? (
          <div className="rp-checkout-card--shipping-info">
            <div className="row">
              <div className="col-md-3 rp-checkout-card--shipping-info--field">
                <label>
                  {t('myReturns.unit')}{' '}
                  <span className="unitRequired ponumberRequired">*</span>
                </label>
                <input
                  className="unit-number"
                  name="unit-number"
                  type="text"
                  value={this.props.stateUnitNumber}
                  onChange={e =>
                    this.props.handleAllUnitNumberChange(e.target.value)
                  }
                />
              </div>
              <div className="col-md-3 rp-checkout-card--shipping-info--field">
                <label>
                  {t('myReturns.serviceOrder')}{' '}
                  <span className="serviceOrderRequired ponumberRequired">
                    *
                  </span>
                </label>
                <input
                  className="serviceOrder-number"
                  name="serviceOrder-number"
                  type="text"
                  value={this.props.stateServiceNumber}
                  onChange={e =>
                    this.props.handleAllServiceNumberChange(e.target.value)
                  }
                />
              </div>
              {activeAccount !== '015411' && (
              <div className="col-md-3 rp-checkout-card--shipping-info--field">
                <label>
                  {t('myReturns.techID')}{' '}
                  <span className="techIDRequired ponumberRequired">*</span>
                </label>
                <input
                  className="techID-number"
                  name="techID-number"
                  type="text"
                  value={this.props.stateTechId}
                  onChange={e =>
                    this.props.handleAllTechIdNumberChange(e.target.value)
                  }
                />
              </div>
              )}
            </div>
          </div>
        ) : (
          ''
        )}
        <div className="rp-checkout-card--shipping-info--alert">
          {this.props.termsOfDelivery && (
            <div className="disclaimer">
              <strong>{t('checkoutPage.termsOfDelivery')}: </strong>
              {this.props.termsOfDelivery}
            </div>
          )}
        </div>
        <div className="rp-checkout-card--payment-method">
          <div className="rp-checkout-card--payment-method--title">
            {t('checkoutPage.paymentMethod')}
            {!this.props.orderConfirmed && this.props.allowChangePaymentMethod && (
              <span
                className="rp-checkout-card--link"
                onClick={this.props.handleShowChangePaymentMethod}
              >
                {t('common.change')}
              </span>
            )}
          </div>
          <div className="rp-checkout-card--payment-method--field">
            {this.props.paymentMethod === '001' ? (
              <React.Fragment>
                <label>{t('checkoutPage.paymentByAccNo')}:</label>
                <p>{t('accountInfoHeader.accountNumber')}</p>#
                {this.props.accountId}
              </React.Fragment>
            ) : this.props.paymentMethod === '002' ||
              this.props.paymentMethod === '004' ? (
              <React.Fragment>{this.renderCreditCardOptions()}</React.Fragment>
            ) : this.props.paymentMethod === '003' ? (
              <React.Fragment>
                <label>Pay by Credit E-Check:</label>
                <p>E-Check</p>
              </React.Fragment>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default CheckoutCard;
